import actions from './menuActionTypes';

export const setNavMenu = (data) => {
    return { type: actions.SET_NAV_MENU, payload: data };
};
